namespace('compass.demographic');

compass.demographic.DupeSelectWidget = compass.defineWidget(function DupeSelectWidget(options) {
	var me = this;

	var _settings = options;
	var d = jQuery.dom.getContext(this);

	var officeName = '';
	if(options.dupes && options.dupes.length){
		officeName = options.dupes[0].officeName;
	}

	var _labels = {
		ID: officeName+" ID",
		positiveButton: "Yes",
		positiveHasHousingHint: "Log in to existing reservation.",
		positiveHasNoHousingHint: "Make my reservation with these details",
		negativeButton: "No",
		negativeHint: "Continue booking."
	};

	var _drawFilled = function (dupe) {
		return d.div({
			className: 'record'
		}, d.div({
				className: 'dupe filled'
			}, d.div({
					className: 'demoInfo'
				}, d.span({
						className: 'name'
				}, dupe.firstName + " " + dupe.lastName),
					d.span({
						className: 'category'
					}, dupe.category)
				),
				d.div({
					className: 'IDInfo'
				}, _labels.ID + ": " + dupe.attendance_id),
				d.div({
					className: 'creation'
				}, "Created on " + dupe.creation)
			), d.div({
					className: 'buttonPane'
				}, d.button({
						className : "secondaryButton"
					}, _labels.positiveButton).activate(function () {
							me.trigger('DupeSelectWidget.ExistingRecord', {
								attendance_id: dupe.attendance_id,
								email: dupe.email,
								housing: dupe.hasHousing
							}
						); }),
					d.span({
						className: 'description'
					}, dupe.hasHousing ? _labels.positiveHasHousingHint : _labels.positiveHasNoHousingHint)
			)
		);
	};

	var _drawUnfilled = function (dupe) {
	};

	var _render = me.render = function (widgetElem) {
		_.each(_settings.dupes, function (dupe) {
			widgetElem.append(dupe.attendance_id ? _drawFilled(dupe) : _drawUnfilled(dupe));
		});

		widgetElem.append(d.div({
			className: 'buttonPane'
		}, d.button({
				className : "secondaryButton"
			}, _labels.negativeButton
			).activate(function () { me.trigger('DupeSelectWidget.NoRecord'); }), d.span({
				className: 'description'
			}, _labels.negativeHint)
		));
		compass.trackPageView('DupeChecker');
	};
}, {
	WUID: 'CRAP',
	widgetName: 'DupeSelectWidget',
	dupes: []
});
